import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';
import { Observable } from 'rxjs';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {RequestsGridComponent} from '../../components/Requests/RequestsGrid.component';

@Component({
  selector: 'my-assignedrequests',
  templateUrl: './AssignedRequests.component.html'
})
export class AssignedRequestsComponent implements OnInit {

    @ViewChild(RequestsGridComponent) requestsGridComponent: RequestsGridComponent;

    public noExistingRequests: boolean;
    userInfo: ent.UserInfo;

    options: any;


    constructor(private authenticationService: serv.AuthenticationService, private requestService: serv.RequestService, private router: Router) 
    {
        
        
    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        
        

    }

    ngAfterViewInit(){
        //this.requestsGridComponent.requestStatusMultiSelectComponent.selectedIDs = [];
        this.requestsGridComponent.requestStatusIDsToSelectOnLoad = [enums.RequestStatusEnum.Submitted];

        this.requestsGridComponent.requestTypeIDsToSelectOnLoad = [enums.RequestTypeEnum.VisitPlanUpdate, enums.RequestTypeEnum.ZRPartnerUpdate];

        this.requestsGridComponent.employeeIDsToSelectOnLoad = [this.userInfo.Employee.ID];
        
        this.requestsGridComponent.salesOfficeIDsToSelectOnLoad = [this.userInfo.Employee.SalesOfficeID];

        Observable.forkJoin([
            this.requestsGridComponent.loadEmployees(),
            this.requestsGridComponent.loadRequestStatuses(),
            this.requestsGridComponent.loadRequestTypes(),
            this.requestsGridComponent.loadSalesOffices()
          ]).subscribe(value => {
                this.requestsGridComponent.onSearchClick(null);
                this.requestsGridComponent.updateRequests.subscribe((x: boolean)=>this.onUpdateRequests(x));
          });

    }

    onUpdateRequests(x: boolean){

        this.requestsGridComponent.onSearchClick(null);

        
    }
}